export const FILTER_TYPES = {
	NORMAL: 'normal',
	EXCLUDE: 'exclude',
};

export const FILTER_ACTIONS = {
    INCLUDE: 'include',
    EXCLUDE: 'exclude',
    NO_FILTER: 'no_filter'
}